import React from "react";
import {
  Box,
  CircularProgress,
  DialogContent,
  Typography,
  useTheme,
} from "@mui/material";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ButtonSecondary } from "src/UI/ButtonSecondary";
import ProgressModalFooter from "../components/ProgressModalFooter";
import ProgressTreeNode from "../components/ProgressTreeNode";
import { ProgressNode } from "../types";

interface OverviewViewProps {
  tree: ProgressNode | null;
  isLoading: boolean;
  hasError: boolean;
  onChangeStatus?: () => void;
}

const OverviewView: React.FC<OverviewViewProps> = ({
  tree,
  isLoading,
  hasError,
  onChangeStatus,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("enrollment-progress");

  return (
    <>
      <DialogContent sx={{ padding: "12px 24px", mt: 1 }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : hasError ? (
          <Typography
            sx={{ fontSize: "14px", color: theme.palette.text.primary }}
          >
            {t("overview.error")}
          </Typography>
        ) : tree ? (
          <ProgressTreeNode node={tree} />
        ) : null}
      </DialogContent>

      {onChangeStatus && (
        <ProgressModalFooter
          right={
            <ButtonSecondary
              size="md"
              endIcon={<ChevronRight size={16} />}
              disabled={!tree}
              onClick={onChangeStatus}
            >
              {t("overview.change-status")}
            </ButtonSecondary>
          }
        />
      )}
    </>
  );
};

export default OverviewView;
